import { render, staticRenderFns } from "./DeleteWelcomeSignOverrideModal.vue?vue&type=template&id=66dd918f"
import script from "./DeleteWelcomeSignOverrideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteWelcomeSignOverrideModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports